import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
	faChevronLeft,
	faChevronRight
} from '@fortawesome/pro-light-svg-icons';

import { Button, Flex } from 'antd';

export default (props: any) => (
	<Flex justify="center" align="center" className={props.className}>

		<Button
			shape="circle"
			onClick={props.onGoToPreviousScenario}
			className="action"
			style={{ marginRight: '1rem' }}
		>
			<FontAwesomeIcon icon={faChevronLeft} />
		</Button>

		<div className={props.fullWidth ? 'w-100' : ''}>{props.children}</div>

		<Button
			shape="circle"
			onClick={props.onGoToNextScenario}
			className="action"
			style={{ marginLeft: '1rem' }}
		>
			<FontAwesomeIcon icon={faChevronRight} />
		</Button>
	</Flex>
);
